"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.actions.run': 'Esegui Test',
    'botTest.actions.results': 'Visualizza Risultati',
};
